import React, { useEffect } from "react";
import { useCombinedStore } from "../store";
import { MessageBoxContainer, CloseButton } from "../styles/MessageBox.styles";

const MessageBox: React.FC = () => {
  const { messageZustand, messageTypeZustand, removeMessageZustand } = useCombinedStore();

  // Remove automaticamente a mensagem após 3 segundos
  useEffect(() => {
    if (messageZustand) {
      const timer = setTimeout(() => {
        removeMessageZustand();
      }, 3000);
      return () => clearTimeout(timer); // Limpa o timer ao desmontar o componente
    }
  }, [messageZustand, removeMessageZustand]);

  if (!messageZustand) return null;

  return (
    <MessageBoxContainer messageType={messageTypeZustand}>
      {messageZustand}
      <CloseButton onClick={removeMessageZustand}>X</CloseButton>
    </MessageBoxContainer>
  );
};

export default MessageBox;
